import Icon from "../../icon";
import { PLUS } from "icons";
import { Card, CardContent } from "ui/components/card";
import { cn } from "utils";
import { COMMON_CLASSES_FOR_CARD } from "./utils";
import { Link } from "react-router-dom";

export default function AddDraftLogCard({ href, className }) {
    return (
        <Link to={href}>
            <Card
                className={cn(
                    COMMON_CLASSES_FOR_CARD,
                    "h-full border-dashed border-2 cursor-pointer",
                    className
                )}
            >
                <CardContent className="flex flex-col gap-3 w-full h-full justify-center items-center">
                    <div className="size-9 flex justify-center items-center  rounded-full bg-red-50 flex-none">
                        <Icon icon={PLUS} className="text-red-900" />
                    </div>
                    <span className="text-sm font-semibold text-foreground">
                        Add Draft Log
                    </span>
                    <p className="text-muted-foreground text-center text-xs">
                        Draft hours to record the time spent on <br /> tasks for the day.
                    </p>
                </CardContent>
            </Card>
        </Link>
    );
}
